module.exports = __webpack_public_path__ + "static/photo_thanos-86c1c3e338d6dfa54d4db81457e5a7a8.jpg";